const RentActions = {
    UPDATE_MASTER: 'UPDATE_RENT_MASTER',
    UPDATE_HISTORY: 'UPDATE_RENT_HISTORY',
}

export default RentActions;